export { Stack, StackItem } from './Stack';
//# sourceMappingURL=index.js.map